const HOURS24 = [
  {
    value: { h: 0, m: 0 },
    label: "12:00 am",
  },
  {
    value: { h: 0, m: 30 },
    label: "12:30 am",
  },
  {
    value: { h: 1, m: 0 },
    label: "1:00 am",
  },
  {
    value: { h: 1, m: 30 },
    label: "1:30 am",
  },
  {
    value: { h: 2, m: 0 },
    label: "2:00 am",
  },
  {
    value: { h: 2, m: 30 },
    label: "2:30 am",
  },
  {
    value: { h: 3, m: 0 },
    label: "3:00 am",
  },
  {
    value: { h: 3, m: 30 },
    label: "3:30 am",
  },
  {
    value: { h: 4, m: 0 },
    label: "4:00 am",
  },
  {
    value: { h: 4, m: 30 },
    label: "4:30 am",
  },
  {
    value: { h: 5, m: 0 },
    label: "5:00 am",
  },
  {
    value: { h: 5, m: 30 },
    label: "5:30 am",
  },
  {
    value: { h: 6, m: 0 },
    label: "6:00 am",
  },
  {
    value: { h: 6, m: 30 },
    label: "6:30 am",
  },
  {
    value: { h: 7, m: 0 },
    label: "7:00 am",
  },
  {
    value: { h: 7, m: 30 },
    label: "7:30 am",
  },
  {
    value: { h: 8, m: 0 },
    label: "8:00 am",
  },
  {
    value: { h: 8, m: 30 },
    label: "8:30 am",
  },
  {
    value: { h: 9, m: 0 },
    label: "9:00 am",
  },
  {
    value: { h: 9, m: 30 },
    label: "9:30 am",
  },
  {
    value: { h: 10, m: 0 },
    label: "10:00 am",
  },
  {
    value: { h: 10, m: 30 },
    label: "10:30 am",
  },
  {
    value: { h: 11, m: 0 },
    label: "11:00 am",
  },
  {
    value: { h: 11, m: 30 },
    label: "11:30 am",
  },
  {
    value: { h: 12, m: 0 },
    label: "12:00 pm",
  },
  {
    value: { h: 12, m: 30 },
    label: "12:30 pm",
  },
  {
    value: { h: 13, m: 0 },
    label: "1:00 pm",
  },
  {
    value: { h: 13, m: 30 },
    label: "1:30 pm",
  },
  {
    value: { h: 14, m: 0 },
    label: "2:00 pm",
  },
  {
    value: { h: 14, m: 30 },
    label: "2:30 pm",
  },
  {
    value: { h: 15, m: 0 },
    label: "3:00 pm",
  },
  {
    value: { h: 15, m: 30 },
    label: "3:30 pm",
  },
  {
    value: { h: 16, m: 0 },
    label: "4:00 pm",
  },
  {
    value: { h: 16, m: 30 },
    label: "4:30 pm",
  },
  {
    value: { h: 17, m: 0 },
    label: "5:00 pm",
  },
  {
    value: { h: 17, m: 30 },
    label: "5:30 pm",
  },
  {
    value: { h: 18, m: 0 },
    label: "6:00 pm",
  },
  {
    value: { h: 18, m: 30 },
    label: "6:30 pm",
  },
  {
    value: { h: 19, m: 0 },
    label: "7:00 pm",
  },
  {
    value: { h: 19, m: 30 },
    label: "7:30 pm",
  },
  {
    value: { h: 20, m: 0 },
    label: "8:00 pm",
  },
  {
    value: { h: 20, m: 30 },
    label: "8:30 pm",
  },
  {
    value: { h: 21, m: 0 },
    label: "9:00 pm",
  },
  {
    value: { h: 21, m: 30 },
    label: "9:30 pm",
  },
  {
    value: { h: 22, m: 0 },
    label: "10:00 pm",
  },
  {
    value: { h: 22, m: 30 },
    label: "10:30 pm",
  },
  {
    value: { h: 23, m: 0 },
    label: "11:00 pm",
  },
  {
    value: { h: 23, m: 30 },
    label: "11:30 pm",
  },
  {
    value: { h: 24, m: 0 },
    label: "12:00 pm",
  },
];

const MONTHS = () => ({
  january: {
    label: "january",
    value: "1",
  },
  february: {
    label: "february",
    value: "2",
  },
  march: {
    label: "march",
    value: "3",
  },
  april: {
    label: "april",
    value: "4",
  },
  may: {
    label: "may",
    value: "5",
  },
  june: {
    label: "june",
    value: "6",
  },
  july: {
    label: "july",
    value: "7",
  },
  august: {
    label: "august",
    value: "8",
  },
  september: {
    label: "september",
    value: "9",
  },
  october: {
    label: "october",
    value: "10",
  },
  november: {
    label: "november",
    value: "11",
  },
  december: {
    label: "december",
    value: "12",
  },
});

export { HOURS24, MONTHS };
